import { useCallback, useState } from "react";
import { SiteLayout } from "@/components/layout/SiteLayout";
import { BeyondSection } from "@/components/home/BeyondSection";
import { CuriositySection } from "@/components/home/CuriositySection";
import { ExperiencesSection } from "@/components/home/ExperiencesSection";
import { FinalCta } from "@/components/home/FinalCta";
import { HomeHero } from "@/components/home/HomeHero";
import { MentorsSection } from "@/components/home/MentorsSection";
import { MomentsSection } from "@/components/home/MomentsSection";
import { GoogleReviewsSection } from "@/components/home/GoogleReviewsSection";
import { VideoTestimonialsSection } from "@/components/home/VideoTestimonialsSection";
import { QuoteSection } from "@/components/home/QuoteSection";
import { SeasonsSection } from "@/components/home/SeasonsSection";
import { ChatModal } from "@/components/modals/ChatModal";
import { HOME_SEO } from "@/data/home";
import { Seo } from "@/lib/seo/Seo";
import { organizationSchema } from "@/lib/seo/schema";

/**
 * Home. Section order follows the content writer's brief:
 * hero > curiosity + subject picker > seasons > quote > experiences > mentors > go beyond + SECI > final CTA.
 */
export default function Home() {
  const [chatOpen, setChatOpen] = useState(false);

  const openChat = useCallback(() => setChatOpen(true), []);
  const closeChat = useCallback(() => setChatOpen(false), []);

  return (
    <SiteLayout onOpenChat={openChat}>
      <Seo
        title={HOME_SEO.title}
        description={HOME_SEO.description}
        path={HOME_SEO.path}
        jsonLd={organizationSchema()}
      />
      <div data-testid="home-page">
        <HomeHero />
        <CuriositySection />
        <SeasonsSection />
        <QuoteSection />
        <ExperiencesSection />
        <MomentsSection />
        <VideoTestimonialsSection />
        <GoogleReviewsSection />
        <MentorsSection />
        <BeyondSection />
        <FinalCta />
      </div>

      <ChatModal open={chatOpen} onClose={closeChat} />
    </SiteLayout>
  );
}
